export const vendorCategoryRouteName = {
  index: "vendor-categories.index",
};

export const vendorCategoryRoute = [
  {
    path: "/vendor-categories",
    name: vendorCategoryRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "vendor_category",
      breadcrumbs: () => {
        return [{ title: "Vendor Category" }];
      },
    },
  },
];
